import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEO_BASE_URL } from '../config';

const SEO = ({
  title,
  description,
  canonical,
  type = 'website',
  image = `${SEO_BASE_URL}/og-image.png`,
  noindex = false
}) => {
  const siteTitle = 'ItinerarySeek';
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} | AI Travel Itinerary Planner`;
  const defaultDescription = 'Create personalized travel itineraries in seconds with AI. Optimized routes, hidden gems, and trips tailored to your preferences. Free to start!';
  const metaDescription = description || defaultDescription;
  const canonicalUrl = canonical || `${SEO_BASE_URL}/`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={metaDescription} />

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Robots */}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      )}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
